import React from "react";
import PropTypes from "prop-types";
import style from "../../stylesheets/FilterOption.module.scss";
import extraStyle from "../../stylesheets/StoreFilter.module.scss";
import mobileStyle from "../../stylesheets/MobileFilter.module.scss";

const BrandFilterOption = ({ filterOption, handleFilterClick }) => {
  const handleClick = () => {
    handleFilterClick({ brand: filterOption });
  };

  const filterOptionName = (
    <div
      className={`${style.filterOptionName} ${extraStyle.filterOptionName} ${mobileStyle.categoryFilterOptionName}`}
    >
      {filterOption.name}
    </div>
  );

  return (
    <div onClick={handleClick}>
      <li value={filterOption.id}>{filterOptionName}</li>
    </div>
  );
};

BrandFilterOption.propTypes = {
  filterOption: PropTypes.object.isRequired,
  handleFilterClick: PropTypes.func.isRequired,
};

export default BrandFilterOption;
